import React, { useState } from "react";

interface ExpandableCardProps {
  schoolName: string;
  title: string;
  description: string;
  content: React.ReactNode;
  identifier: string;
}

const ExpandableCard: React.FC<ExpandableCardProps> = ({
  schoolName,
  title,
  description,
  content,
  identifier,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div className="wp-block-k12-school-content-wrapper">
      <div className="wp-block-k12-section container-fluid bg-color-light-gray-3 p-3rem g-0">
        <div className="row">
          <div className="col-12 g-0">
            <div className="wp-block-k12-section container-fluid bg-transparent">
              <div className="row">
                <div className="col-12 g-0">
                  <p className="eyebrow">
                    <strong>{schoolName}</strong>
                  </p>
                  <h2 className="wp-block-heading">{title}</h2>
                  <p>{description}</p>
                </div>
              </div>
            </div>

            {/* Accordion Section */}
            <div className="wp-block-k12-show-more-block">
              <div className="accordion" id={`accordion-${identifier}`}>
                <div className="accordion-item">
                  <div
                    id={`content-${identifier}`}
                    className={`accordion-collapse iframe-container mb-5 collapse ${isExpanded ? "show" : ""}`}
                    aria-labelledby={`flush-${identifier}`}
                    data-bs-parent={`accordion-${identifier}`}
                  >
                    <div className="accordion-body bg-transparent p-3">{content}</div>
                  </div>

                  <span className="accordion-header" id={`flush-${identifier}`}>
                    <button
                      className={`accordion-button ${isExpanded ? "" : "collapsed"}`}
                      type="button"
                      onClick={toggleExpand}
                      data-bs-toggle="collapse"
                      data-bs-target={`#content-${identifier}`}
                      aria-expanded={isExpanded}
                      aria-controls={`content-${identifier}`}
                    >
                      {/* <span className={isExpanded ? "Show Less" : "Show More"}>{isExpanded ? "Show Less" : "Show More"}</span> */}
                      <span className="show-more">Show More</span>
                      <span className="show-less">Show Less</span>
                    </button>
                  </span>
                </div>
              </div>
            </div>
            {/* End Accordion Section */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpandableCard;
